import { TYPES } from "./types";
import { tkt1TrustedStoryService } from "../services"; 
import { setFlag } from "./miscAction";
import { CONFIGS } from "../configs";

export const getTKT1TrustedStories = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.getTrustedStories(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORIES_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORIES_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedStoryByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.getTrustedStoryByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedStoryByMID = (mid) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.getTrustedStoryByMID(mid);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORY_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1TrustedStoryTemplates = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.getTrustedStoryTemplates(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_TRUSTED_STORY_TEMPLATES_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1TrustedStories = (query) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.searchTrustedStories(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_TRUSTED_STORIES_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_TRUSTED_STORIES_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1TrustedStory = (storyData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.createTrustedStory(storyData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_STORY_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_TRUSTED_STORY_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1TrustedStory = (id, storyData) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.updateTrustedStory(id, storyData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_STORY_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_TRUSTED_STORY_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1TrustedStory = (id) => async (dispatch) => {
  try {
    const result = await tkt1TrustedStoryService.deleteTrustedStory(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_STORY_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_TRUSTED_STORY_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1TrustedStoryAction = {
  getTKT1TrustedStories,
  getTKT1TrustedStoryByID,
  getTKT1TrustedStoryByMID,
  getTKT1TrustedStoryTemplates,
  searchTKT1TrustedStories,
  createTKT1TrustedStory,
  updateTKT1TrustedStory,
  deleteTKT1TrustedStory
};
